module.exports = __webpack_public_path__ + "img/empty.aaef5e18.png";